import React, { useEffect } from "react";
import { TextField, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector } from "react-redux";
import "./IndividualTask.css";
import Locale from "../../../locales";
import {
  EVENT_DESCRIPTION,
  EVENT_TITLE,
} from "../../../constants/textFieldMaxLengths";

const IndividualTask = ({
  task,
  updateTaskHandler,
  updateSessionDuration,
  deleteIndividualTask,
  singleTaskSession,
  index,
}) => {
  const loading = useSelector((state) => state.teacherReducer.loading);
  const { title, description, duration } = task;

  useEffect(() => {
    updateSessionDuration();
  }, []);

  const changeValuesHandler = (event) => {
    switch (event.target.name) {
      case "title":
        updateTaskHandler(event.target.name, event.target.value, index);
        break;
      case "description":
        updateTaskHandler(event.target.name, event.target.value, index);
        break;
      case "duration":
        updateTaskHandler(
          event.target.name,
          parseInt(event.target.value, 10),
          index,
        );
        updateSessionDuration();
        break;
      default:
        break;
    }
  };

  return (
    <div className="individual-task-container">
      <div className="task-info-container">
        <div>
          <TextField
            name="title"
            type="text"
            label={Locale.t("title")}
            helperText={`${title.length}/${EVENT_TITLE}`}
            required
            value={title}
            error={title.length > EVENT_TITLE}
            // inputProps={{ maxLength: EVENT_TITLE }}
            onChange={(event) => changeValuesHandler(event)}
          />
        </div>
        <div>
          <TextField
            type="text"
            name="description"
            label={Locale.t("description")}
            helperText={`${description.length}/${EVENT_DESCRIPTION}`}
            required
            value={description}
            error={description.length > EVENT_DESCRIPTION}
            onChange={(event) => changeValuesHandler(event)}
          />
        </div>
      </div>
      <div className="individual-task-duration-container">
        <TextField
          type="number"
          name="duration"
          InputProps={{ inputProps: { min: 0 } }}
          label={Locale.t("duration")}
          required
          value={duration}
          onChange={(event) => changeValuesHandler(event)}
        />
      </div>
      <div className="individual-task-container">
        {!singleTaskSession && (
          <Tooltip arrow placement="right" title="Delete">
            <DeleteIcon
              disabled={loading}
              onClick={() => deleteIndividualTask(index)}
              type="button"
              className="delete-button"
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default IndividualTask;
